/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferContactRoleRequest } from '../../models/offer-contact-role-request';

export interface ChangeOfferContactRole$Params {
  id: number;
  contactId: number;
      body: OfferContactRoleRequest
}

export function changeOfferContactRole(http: HttpClient, rootUrl: string, params: ChangeOfferContactRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, changeOfferContactRole.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('contactId', params.contactId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

changeOfferContactRole.PATH = '/offers/{id}/contacts/{contactId}/role';
